export default "__VITE_ASSET__COFfKPCl__"